import { render, staticRenderFns } from "./superBros.vue?vue&type=template&id=12747243&scoped=true"
import script from "./superBros.vue?vue&type=script&lang=js"
export * from "./superBros.vue?vue&type=script&lang=js"
import style0 from "./superBros.vue?vue&type=style&index=0&id=12747243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12747243",
  null
  
)

export default component.exports